
  <manage-wrapper
  *ngIf="!!entity"
  [canEditMain]="true"
  [entityTitle]="entity.name"
  [tabGroups]="tabGroups"
  [hideLabels]="true"
  [selectedTab]="selectedTab"
  [readOnly]="false"
  [deleteTitle]="'Delete this exhibitor template'"
  [titlePlaceholder]="'Exhibitor template name...'"
  [backgroundColor]="'#41474F'"
  [dialogTitle]="'Clipboard Exhibitor Details'"
  [canDuplicate]="false"
  [type]="'exhibitor'"
  (onDone)="exit()"
  (onChangeTab)="changeTab($event)"
  (saveTitle)="updateTitle($event)"
  (onDelete)="delete()"
>
  <ng-container *ngIf="!selectedTab || selectedTab?.id === 'details'">
    <div class="uploaders-holder">
      <image-uploader 
          [id]="entity.id"
          (newUrls)="changeImage($event, 'logo')"
          [immediate]="true" 
          [isLogo]="true"
          [isTemplate]="true"
          [displayType]="imageUploaderDisplayTypes.widePodLogo"
          [thumbUrl]="entity.logoUrl" 
          [photoUrl]="entity.fullLogoUrl"
          [eventId]="data.accountId"
          [saveName]="entity.name"
          [type]="'exhibitor'" 
          [subtype]="'logo'" 
          [placeholder]="'Add logo'" 
          [uploadText]="'UPLOAD LOGO'"
      ></image-uploader>
    </div>
    <h3 class="description-title">Description</h3>
    <joi-input class="description" [disabled]="false" [italicPlaceholder]="true" [(model)]="entity.description" [type]="'textarea'" [returnable]="true" [placeholder]="'Click to add a description...'" (joiChange)="saveEntity()"></joi-input>

    <manage-social [links]="entity?.social" (saveLinks)="saveSocialLinks($event)"></manage-social>

    <manage-call-to-action
      [entity]="entity"
      [ctaProp]="'callToAction'"
      [urlProp]="'callToActionUrl'"
      [readOnly]="false"
      (ctaDetailsChanged)="saveEntity()"
    ></manage-call-to-action>

    <hr class="big-rule"/>

    <manage-contact-details
      [entity]="entity"
      [entityName]="'Exhibitor'"
      [nameProp]="'contactName'"
      [numberProp]="'contactNumber'"
      [emailProp]="'contactEmail'"
      [readOnly]="false"
      (contactDetailsChanged)="saveEntity()"
    ></manage-contact-details>
  </ng-container>
</manage-wrapper>